/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import autobind from "autobind-decorator";
import {FormControl, InputGroup} from "react-bootstrap";
import React from "react";

export class NumberFieldEditor extends BaseFieldEditor {
	@autobind
	_render() {
		const {Value, OnUpdate} = this.props;
		const {prefix, suffix, className} = this.getFieldDefCustomData();

		return <InputGroup className={`${className ?? ""} ${prefix ? 'has-prefix' : ''} ${suffix ? 'has-suffix' : ''}`}>
			{
				prefix &&
				<InputGroup.Prepend>
					<InputGroup.Text>{prefix}</InputGroup.Text>
				</InputGroup.Prepend>
			}
			<FormControl
				type="number"
				step={1}
				value={Value != null ? Value : ""}
				onChange={(x) => OnUpdate?.(x.target.value)}
			/>
			{
				suffix &&
				<InputGroup.Append>
					<InputGroup.Text>{suffix}</InputGroup.Text>
				</InputGroup.Append>
			}
		</InputGroup>;
	}
}